var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.32 22.484V13.84H9.447v8.644h2.871Zm-1.436-9.824c1.001 0 1.624-.664 1.624-1.493-.018-.848-.623-1.494-1.605-1.494s-1.624.646-1.624 1.494c0 .83.623 1.493 1.587 1.493h.018Zm3.024 9.824h2.87v-4.827c0-.258.02-.516.095-.7.207-.517.68-1.051 1.473-1.051 1.038 0 1.454.792 1.454 1.954v4.624h2.87v-4.956c0-2.655-1.416-3.89-3.304-3.89-1.549 0-2.229.866-2.607 1.456h.02V13.84h-2.87c.037.81-.001 8.644-.001 8.644Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;